import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { aboutImage } from '../mock';
import Seo from '../components/Seo';

const About = () => {
  return (
    <div className="bg-white min-h-screen">
      <Seo
        title="About Satis Furniture | Family-Owned Furniture Outlet in Campsie, Sydney"
        description="Learn the story behind Satis Furniture in Campsie, Sydney. Family-owned outlet offering brand new and factory second furniture at unbeatable prices. Free delivery within 10km."
        path="/about"
      />
      <Header />

      {/* Page Hero */}
      <section className="relative w-full h-[400px] md:h-[450px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center pt-20">
          <div className="inline-block border-2 border-white/70 rounded-full px-5 py-2 mb-6">
            <span className="text-white text-xs md:text-sm tracking-wide">
              Free home delivery in Sydney within 10kms of store
            </span>
          </div>
          <h1 className="text-white text-5xl md:text-7xl lg:text-[88px] font-medium mb-8 tracking-tight font-display-serif leading-[1.05]">About Us</h1>
          <a
            href="tel:+61411418088"
            className="inline-block bg-white text-black px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors btn-transition"
          >
            Call Now
          </a>
        </div>
      </section>

      {/* Who We Are */}
      <section className="py-20 md:py-28 px-6 md:px-10 bg-white">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-gray-100 shadow-lg">
                <img
                  src={aboutImage}
                  alt="About Satis Furniture"
                  className="w-full h-full object-cover"
                  onError={(e) => { e.currentTarget.src = 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&q=80'; }}
                />
              </div>
            </div>

            <div>
              <p className="text-xs md:text-sm text-gray-500 mb-3 tracking-[0.3em] uppercase">
                Our Story
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-black mb-8 tracking-tight font-display-serif leading-[1.05]">
                Who we are
              </h2>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-10">
                Welcome to Satis Furniture. Based at 12 Perry Street in Campsie, NSW, we’re a family-owned outlet store offering a wide range of furniture for every room — from brand-new home pieces to quality factory seconds and office furniture. We pride ourselves on prices no one can beat, free delivery within Sydney (conditions apply), and plenty of parking right out the front. Drop in any day of the week and we’ll help you find exactly what you need.
              </p>

              <h3 className="text-lg font-bold text-black mb-6">
                For further details contact us on:
              </h3>

              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                    <Phone className="w-4 h-4 text-black" strokeWidth={1.5} />
                  </div>
                  <a href="tel:+61411418088" className="text-base text-gray-700 hover:text-black">
                    (02) 97872567 / 0430890808 / 0411418088
                  </a>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                    <Mail className="w-4 h-4 text-black" strokeWidth={1.5} />
                  </div>
                  <a href="mailto:wangjianjohn@hotmail.com" className="text-base text-gray-700 hover:text-black">
                    wangjianjohn@hotmail.com
                  </a>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-4 h-4 text-black" strokeWidth={1.5} />
                  </div>
                  <p className="text-base text-gray-700">12 Perry St, Campsie NSW 2194, Australia</p>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-4 h-4 text-black" strokeWidth={1.5} />
                  </div>
                  <p className="text-base text-gray-700">Monday to Sunday: 10:30 am — 5:30 pm</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
